module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABKUlEQVQ4T8WTwU3DQBBF304FpoOkA6eDUAEUgASIcxSoAKggaQCRAwVABYEKgAqggwAF7KCJ14oVzSa2ZClzsWTtvv3/z0yg5wo98zg4sACZQnwBPjx3XRQWEJbAEFDQYw/aFljDAugYZA564kHbALdg/FRWZeFB2wBLkHeIZtFg3+lrD32B3gPzOs9dwAIYVDmZmvgHMoE4qqDrPFMEter1D7eSzVACBnsDeYT4ADxBmHkwI3nAZmbXwBnIFcRLkDFwDvpZNWejLGd5uwGDlN8tyBHEG8BUuzPoKJQ70AtQu2QNqHO0gV6m/LIwz3IJ4RXUrC6SjaZqe2hneRk2oc+5buaouS4nKCvgN9eArrtsA30K0YY2bcc+w/k53H8zc6LN6nWC9w78BxpXWBU3kahuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/link.png
// module id = 2O7v
// module chunks = 1